import React from "react"
import PropTypes from "prop-types"

import { getCountryFlagByCode, getCountryNameByCode } from "shared/services/countries"

import styles from "./CountryLabel.css"

function CountryLabel({ code, size, label }, { t: translate }) {
  const name = getCountryNameByCode(code)
  const flag = getCountryFlagByCode(code)
  return (
    <div className={styles.root}>
      {flag ? <img
        className={[styles.flag, styles.label, styles[`size${size}`] || styles.size24].join(" ")}
        src={flag}
        alt={name}
        data-tip={translate(name)}
        data-effect="solid"
      /> : null}
      {label || translate(name)}
    </div>
  )
}

CountryLabel.propTypes = {
  code: PropTypes.string.isRequired,
  size: PropTypes.number,
  label: PropTypes.node,
}

CountryLabel.defaultProps = {
  size: 24,
  label: null,
}

CountryLabel.contextTypes = {
  t: PropTypes.func.isRequired,
}

export default CountryLabel



// WEBPACK FOOTER //
// ./src/shared/components/CountryLabel/CountryLabel.js